import { ASSET_RESTORE_PROPERTIES } from '~/constant'

export const removeExtraProperties = preparedAsset => {
  const resultAsset = { ...preparedAsset }
  ASSET_RESTORE_PROPERTIES.forEach(prop => {
    if (prop in resultAsset) {
      delete resultAsset[prop]
    }
  })
  return resultAsset
}
